import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  style: { color: '#d8d8db' }
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 3,
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

import {
  computed,
  ref,
  createVNode,
  toRaw,
  onMounted,
  watch
} from 'vue'
import {
  ListTypeMap,
  GutterConfig,
  CoursewareType,
  CoursewareTypeMap
} from '../config'
import { shareModeEnum } from '@/utils/dataMap'
import { message, Modal } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { debounce } from '@/utils/common'
import { addInstitutionDownloadLog, addInstitutionViewLog, copyInstitutionShareCourseware, getInstitutionCourseware } from '../service'
import FlashCoursewareCard from './FlashCoursewareCard.vue'
import AudioCoursewareCard from './AudioCoursewareCard.vue'
import ImageCoursewareCard from './ImageCoursewareCard.vue'
import PptCoursewareCard from './PptCoursewardCard.vue'
import VideoCoursewareCard from './VideoCoursewareCard.vue'
import SpeakCoursewareCard from './SpeakCoursewareCard.vue'
import PlanCoursewareCard from './PlanCoursewareCard.vue'
import Empty from '@/components/common/Empty.vue'
import { CoursewareTypeOpts } from '@/views/courseware-database/config'


export default /*#__PURE__*/_defineComponent({
  props: {
  form: {
    type: Object
  },
  type: {
    type: String,
    default: ListTypeMap.CARD
  },
  contextPage: {
    type: Number,
    default: 1
  },
  checkPersonalCloudSpace: Function
},
  emits: ['onPreview', 'update:contextPage'],
  setup(__props, { expose, emit }) {

const props = __props




// 搜索栏参数
const formData = computed<any>(() => props.form)

// 卡片模式还是列表模式
const tableType = computed<string>(() => props.type)

// 表格数据
const tableData = ref<any[]>([])

const loading = ref<boolean>(true)

// 兼容用户切换页面时保存的上下文中页码不为1的情况
const contPage = ref<number>(props.contextPage)

const columns = [
  {
    title: '课件名称',
    dataIndex: 'name',
    ellipsis: true
  },
  {
    title: '课件类型',
    dataIndex: 'type',
    slots: { customRender: 'type' },
    ellipsis: true
  },
  {
    title: '教材',
    dataIndex: ['book', 'name'],
    ellipsis: true
  },
  {
    title: '章节',
    dataIndex: 'section_breadcrumb',
    ellipsis: true
  },
  {
    title: '制作者',
    dataIndex: 'author_name',
    ellipsis: true
  },
  {
    title: '标签',
    dataIndex: 'tags',
    ellipsis: true,
    slots: { customRender: 'tags' }
  },
  {
    title: '人气值',
    dataIndex: ['popularity', 'popularity']
  },
  {
    title: '下载量',
    dataIndex: ['popularity', 'download_num']
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    ellipsis: true
  },
  {
    title: '修改时间',
    dataIndex: 'updated_at',
    ellipsis: true
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 150,
    slots: { customRender: 'action' }
  }
]
// 第一次进入
const isFirst = ref(false)

// 检索为空
const locale = {
  emptyText: createVNode(Empty, { value: isFirst.value })
}

watch(isFirst, (newValue) => {
  if (newValue === true) {
    locale.emptyText = createVNode(Empty, { value: isFirst.value })
  }
})

// 请求接口获取数据
const handleGetListInfo = debounce(async (params: any) => {
  const allTypes = CoursewareTypeOpts.map((type) => {
    return type.value
  })
  const qParams = {
    page: pagination.value.current,
    ...toRaw(formData.value),
    ...params,
    per_page: pagination.value.pageSize,
    types: (!formData.value?.types || formData.value?.types?.length === 0) ? allTypes : formData.value.types,
    // 学校的标识码是1，区域是2
    owner_type: 1
  }
  try {
    loading.value = true
    const { items, meta } = await getInstitutionCourseware(qParams)
    tableData.value = items
    pagination.value = { ...toRaw(pagination.value), ...meta, current: meta.current_page, onChange: handleTableChange, showTotal: (total: number) => `共${total}条` }
    loading.value = false
  } catch (error) {
    console.log(error)
    tableData.value = []
    loading.value = false
  }
})

const handleTableChange = (page: any) => {
  pagination.value.current = page
  handleSearch()
}

// 分页配置
const pagination = ref({
  current: 1,
  total: 1,
  pageSize: 12,
  showTotal: (total:number) => `共${total}条`,
  showQuickJumper: true,
  onChange: handleTableChange
})

// 搜索操作
const handleSearch = (value: any = {}) => {
  handleGetListInfo(value)
}

// 本地更新下载量数据
const handleUpdateDownloadNum = (id: any) => {
  tableData.value.forEach(record => {
    if (record.id === id) {
      if (record.popularity && record.popularity.download_num) {
        record.popularity.download_num++
      } else {
        record.popularity.download_num = 1
      }
    }
  })
}

// 本地更新下载量数据
const handleUpdateViewNum = (id:any) => {
  tableData.value.forEach(record => {
    if (record.id === id) {
      if (record.popularity && record.popularity.popularity) {
        record.popularity.popularity++
      } else {
        record.popularity.popularity = 1
      }
    }
  })
}

// 复制
const handleCopy = async (value: any) => {
  try {
    loading.value = true
    if (props?.checkPersonalCloudSpace) {
      const res = await props.checkPersonalCloudSpace()
      if (!res) {
        loading.value = false
        return
      }
    }

    const params = { area_public_courseware_id: value.id }
    addInstitutionDownloadLog(value.id)
    await copyInstitutionShareCourseware(params)
    message.success('添加到我的课件成功')
    handleUpdateDownloadNum(value.id)
    loading.value = false
  } catch (error) {
    console.log(error)
    message.error('添加到我的课件失败，请重试')
    loading.value = false
  }
}

const handlePreview = (record: any) => {
  addInstitutionViewLog(record.id)
  handleUpdateViewNum(record.id)
  emit('onPreview', record)
}

// 显示警告
const handleShowWarning = (value: any) => {
  Modal.confirm({
    title: '是否确认将课件添加到我的课件中',
    icon: createVNode(ExclamationCircleOutlined),
    closable: true,
    onOk: () => handleCopy(value),
    onCancel: () => {
      Modal.destroyAll()
    }
  })
}

onMounted(() => {
  if (contPage.value > 1) {
    handleSearch({ page: contPage.value })
    emit('update:contextPage', 1)
  } else {
    handleSearch()
    isFirst.value = true
  }
  // isFirst.value = true
})

expose({
  handleSearch,
  getCurrentPage: () => pagination.value.current
})


return (_ctx: any,_cache: any) => {
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_a_list, {
      dataSource: tableData.value,
      pagination: pagination.value,
      grid: _unref(GutterConfig),
      loading: loading.value,
      locale: locale
    }, {
      renderItem: _withCtx(({ item }) => [
        (item.type === _unref(CoursewareType).PPT)
          ? (_openBlock(), _createBlock(_component_a_list_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(PptCoursewareCard, {
                  value: item,
                  onOnCopy: handleCopy,
                  onOnPreview: handlePreview
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.type === _unref(CoursewareType).IMAGE)
          ? (_openBlock(), _createBlock(_component_a_list_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(ImageCoursewareCard, {
                  value: item,
                  onOnCopy: handleCopy,
                  onOnPreview: handlePreview
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.type === _unref(CoursewareType).VIDEO)
          ? (_openBlock(), _createBlock(_component_a_list_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(VideoCoursewareCard, {
                  value: item,
                  onOnCopy: handleCopy,
                  onOnPreview: handlePreview
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.type === _unref(CoursewareType).AUDIO)
          ? (_openBlock(), _createBlock(_component_a_list_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(AudioCoursewareCard, {
                  value: item,
                  onOnCopy: handleCopy,
                  onOnPreview: handlePreview
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.type === _unref(CoursewareType).FLASH)
          ? (_openBlock(), _createBlock(_component_a_list_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(FlashCoursewareCard, {
                  value: item,
                  onOnCopy: handleCopy,
                  onOnPreview: handlePreview
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.type === _unref(CoursewareType).SPEAK)
          ? (_openBlock(), _createBlock(_component_a_list_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(SpeakCoursewareCard, {
                  value: item,
                  onOnCopy: handleCopy,
                  onOnPreview: handlePreview
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (item.type === _unref(CoursewareType).PLAN)
          ? (_openBlock(), _createBlock(_component_a_list_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createVNode(PlanCoursewareCard, {
                  value: item,
                  onOnCopy: handleCopy,
                  onOnPreview: handlePreview
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "pagination", "grid", "loading"]), [
      [_vShow, _unref(tableType) === _unref(ListTypeMap).CARD]
    ]),
    _withDirectives(_createVNode(_component_a_table, {
      dataSource: tableData.value,
      columns: columns,
      pagination: pagination.value,
      locale: locale,
      scroll: { x: 2000 },
      rowKey: "id"
    }, {
      tags: _withCtx(({ text }) => [
        (!text || !text.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "--"))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(_component_a_tooltip, {
                title: text.map(tItem => tItem.tag).toString(),
                placement: "topLeft"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(text, (item) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: item.tag
                    }, [
                      _createVNode(_component_a_tag, { class: "tag_item_label" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.tag), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["title"])
            ]))
      ]),
      type: _withCtx(({ text }) => [
        _createElementVNode("div", null, _toDisplayString(_unref(CoursewareTypeMap)[text]), 1)
      ]),
      action: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            (record.type !== _unref(CoursewareType).FLASH)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: () => handlePreview(record)
                }, "预览", 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "预览")),
            _createVNode(_component_a_divider, { type: "vertical" }),
            (record.share_mode !== _unref(shareModeEnum).NOCOPY)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  onClick: () => handleShowWarning(record)
                }, "获取", 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "获取"))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["dataSource", "pagination"]), [
      [_vShow, _unref(tableType) === _unref(ListTypeMap).LIST]
    ])
  ]))
}
}

})